

import * as fileApi from '@/api/file';
import GuiFileDialog from '@/components/guiFileDialog';
import { App, Button, Dropdown, Layout, MenuProps, Space } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

const { Content } = Layout;

const JsmolPage: React.FC = () => {
    const { message } = App.useApp();

    const containerRef = useRef<HTMLDivElement>(null);
    /** @ts-ignore */
    const $3Dmol = window.$3Dmol;
    const viewer = useRef<any>(null);
    const { t } = useTranslation('common');

    useEffect(() => {
        const element = containerRef.current;
        if (element) {
            viewer.current = $3Dmol.createViewer(element);
        }
    }, []);


    // const handleImportClick = () => {
    //     setUploadDialogVisible(true);
    // };
    // const [uploadDialogVisible, setUploadDialogVisible] = useState(false);

    // const uploadFile = async (files: UploadFile[], _path: string) => {
    //     // Handle file upload
    //     for (const file of files) {
    //         fileReadHandler(file);
    //     }
    //     return { ok: true, message: 'File uploaded successfully', data: undefined };
    // }

    // const fileReadHandler = (file: UploadFile) => {
    //     const fileSuffix = file.name.split('.').pop();
    //     switch (fileSuffix) {
    //         case 'xyz':
    //             const reader = new FileReader();
    //             reader.onload = (e) => {
    //                 const content = e.target?.result;
    //                 if (content) {
    //                     viewer.current.removeAllModels()
    //                     xyzReadHandler(content as string);
    //                 } else {
    //                     message.error('Failed to load file');
    //                 }
    //             };
    //             reader.readAsText(file.originFileObj as Blob);
    //             break;
    //         default:
    //             break;
    //     }
    // }

    const [guiFileDialogVisible, setGuiFileDialogVisible] = useState(false);

    const fileSelectHandler = async (filePath: string) => {
        const content = await fileApi.getRawFileResource(filePath)
        if (content) {
            viewer.current.removeAllModels()
            xyzReadHandler(content);
            setGuiFileDialogVisible(false);
        } else {
            message.error(t('gui.load_failed'));
        }
    };

    const xyzReadHandler = (content: string) => {

        console.log('File content:', content);
        // 加载 XYZ 格式分子数据
        viewer.current.addModel(content, "xyz"); // 指定数据类型为 'xyz'
        viewer.current.setStyle({}, { sphere: { scale: 0.3 }, stick: { radius: 0.2 } });
        // 渲染分子模型
        viewer.current.zoomTo(); // 自动调整到适合视图
        viewer.current.render(); // 渲染模型
    }



    const fileItems: MenuProps['items'] = [{
        key: 1,
        label: 'Import From Local',
        // onClick: handleImportClick,
    },
    {
        key: 2,
        label: 'Import From Lab',
        onClick: () => setGuiFileDialogVisible(true),
    }
    ]

    return (
        <Layout className="h-screen">
            {/* <UploadDialog targetDir={'local'} visible={uploadDialogVisible} onClose={() => setUploadDialogVisible(false)} /> */}
            <GuiFileDialog visible={guiFileDialogVisible} onClose={() => setGuiFileDialogVisible(false)} onSelect={fileSelectHandler} />
            <Space className=' bg-slate-50 dark:bg-[#252526]'>
                <Dropdown menu={{ items: fileItems }}>
                    <Button type="text">
                        File
                    </Button>
                </Dropdown>
            </Space>
            <Content className="bg-gray-300 dark:bg-[#333333] flex-grow">
                <div ref={containerRef} className="w-full h-full relative">
                </div>
            </Content>
        </Layout>
    );
};

export default JsmolPage;